<p-dialog
  [(visible)]="visible"
  [draggable]="false"
  [resizable]="false"
  [modal]="true"
  [closable]="true"
  [header]="dialogTitle"
  [appendTo]="'body'"
  [styleClass]="'platform-dialog'"
>
  <ng-template pTemplate="header">
    <div class="dialog-header" [attr.data-subtitle]="isEditing ? ('platformsCrud.dialogSubtitle.edit' | transloco) : ('platformsCrud.dialogSubtitle.new' | transloco)">
      <span class="dialog-title">{{ dialogTitle }}</span>
    </div>
  </ng-template>

  <form [formGroup]="platformForm" (ngSubmit)="onSubmit()" (keydown.enter)="submitOnEnterSafe($event)" class="form-container">
    <div class="form-group">
      <!-- Platform Information Section -->
      <div class="form-section">
        <div class="form-field">
          <app-input
            [label]="'platformsCrud.fields.name' | transloco"
            [placeholder]="'platformsCrud.fields.namePlaceholder' | transloco"
            formControlName="name"
            [required]="true"
            [error]="!!platformForm.get('name')?.invalid && !!platformForm.get('name')?.touched"
            [errorMessage]="getErrorMessage('name') || ''"
            size="medium"
          ></app-input>
        </div>

        <div class="form-field">
          <app-input
            [label]="'platformsCrud.fields.url' | transloco"
            [placeholder]="'platformsCrud.fields.urlPlaceholder' | transloco"
            formControlName="link"
            [error]="!!platformForm.get('link')?.invalid && !!platformForm.get('link')?.touched"
            [errorMessage]="getErrorMessage('link') || ''"
            size="medium"
          ></app-input>
        </div>

      </div>
    </div>

    <!-- Form Actions -->
    <div class="form-actions">
      <app-button
        [label]="actionButtonLabel"
        type="submit"
        size="medium"
        [disabled]="isLoading"
        [loading]="isLoading"
        class="submit-button"
      ></app-button>
    </div>
  </form>
</p-dialog>
